import { useEffect, useState } from 'react';
import { getApiBaseUrl } from '../utils/apiBaseUrl';
import { cohortStartsFrom, nextCohortStartFrom } from '../components/course/nextLiveClass';

/**
 * The next live Bootcamp cohort start, read from bootcamp-data (Rob,
 * 2026-10-28). The pricing page uses it to say "Next live class: Wed, Mar 17,
 * 2027" on a closed live row. Null while loading, on error, or when no future
 * cohort exists; callers then fall back to catalog metadata or "dates coming
 * soon". No date is ever invented here.
 */
const useNextLiveCohortStart = ({ courseId } = {}) => {
  const [nextStart, setNextStart] = useState(null);
  const resolvedCourseId = courseId || process.env.REACT_APP_AI_BOT_BUILDER_BOOTCAMP_COURSE_ID;

  useEffect(() => {
    if (!resolvedCourseId) return undefined;
    const controller = new AbortController();
    const API_URL = getApiBaseUrl() || 'https://api.botspot.trade';
    Promise.resolve()
      .then(() =>
        fetch(`${API_URL}/courses/${resolvedCourseId}/bootcamp-data`, {
          signal: controller.signal,
        }),
      )
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!data) return;
        const starts = cohortStartsFrom(data.sessionGroups).map((entry) => entry.startsAt);
        setNextStart(nextCohortStartFrom(starts));
      })
      .catch(() => {
        /* the pricing row falls back to catalog metadata */
      });
    return () => controller.abort();
  }, [resolvedCourseId]);

  return nextStart;
};

export default useNextLiveCohortStart;
